import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from '@mm/components';
import { StoreState } from '@mm/state/store-interfaces';
import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import AttributeContainingTextInput from '../../../editor/components/AttributeContainingTextInput/AttributeContainingTextInput';
import AttributePicker from '../../components/AttributePicker/AttributePicker';
import { EmojiPicker } from '../../components/EmojiPicker/EmojiPicker';
import { useEmailWidgetHandlers } from '../../helpers/widget-helpers/use-email-widget-handlers';
import { EmailWidgetProps } from './EmailWidget';

export const EmailToContactWidget = (props: EmailWidgetProps) => {
  const { isExpanded } = props;
  const {
    subjectValue,
    previewTextValue,
    bodyValue,
    onChangeSubject,
    onChangePreviewText,
    onChangeBody,
    onBlur,
    updateInsertEmojiBody,
    setEmailBodyRef,
    setEmailSubjectRef,
    setEmailPreviewTextRef,
    updateInsertEmojiSubject,
    updateInsertEmojiPreviewText,
    updateInsertAttributeBody,
    updateInsertAttributeSubject,
    updateInsertAttributePreviewText,
  } = useEmailWidgetHandlers(props);

  const attributes = useSelector(
    (state: StoreState) => state.attribute.entities,
  );

  if (!isExpanded) {
    return subjectValue ? (
      <div className="widget-component__collapsed-content">{subjectValue}</div>
    ) : null;
  }
  return (
    <div
      className={classnames(
        'email-widget__wrapper',
        'email-widget--to-contact',
        'email-widget--startbots-layout',
      )}
    >
      <div className="email-widget__container">
        <div className="email-widget__input-container">
          <div className="email-widget__input-title">
            <span>Email subject</span>
            <div className="widget-common__heading widget-common__icons-container email-widget__top-container">
              <AttributePicker
                color="#9b9b9b"
                className="email-widget__attribute-picker"
                onAttributePicked={updateInsertAttributeSubject}
              />
              <EmojiPicker
                className="email-widget__emoji-picker"
                onEmojiPicked={updateInsertEmojiSubject}
              />
            </div>
          </div>
          <div>
            <AttributeContainingTextInput
              className="email-widget__input"
              value={subjectValue}
              onChange={onChangeSubject}
              onBlur={onBlur}
              attributes={attributes}
              placeholder="Enter subject"
              inputRef={setEmailSubjectRef}
            />
          </div>
        </div>
      </div>
      <div className="email-widget__container">
        <div className="email-widget__input-container">
          <div className="email-widget__input-title">
            <div className="email-widget__input-title-left">
              <span>Email preview</span>
              <Tooltip anchorElement={<QuestionCircleOutlined />}>
                The lighter text that shows after the subject in your
                recipients' inboxes.
              </Tooltip>
            </div>
            <div className="widget-common__heading widget-common__icons-container email-widget__top-container">
              <AttributePicker
                color="#9b9b9b"
                className="email-widget__attribute-picker"
                onAttributePicked={updateInsertAttributePreviewText}
              />
              <EmojiPicker
                className="email-widget__emoji-picker"
                onEmojiPicked={updateInsertEmojiPreviewText}
              />
            </div>
          </div>
          <div>
            <AttributeContainingTextInput
              className="email-widget__input"
              value={previewTextValue}
              onChange={onChangePreviewText}
              onBlur={onBlur}
              attributes={attributes}
              placeholder=""
              inputRef={setEmailPreviewTextRef}
            />
          </div>
        </div>
      </div>
      <div className="email-widget__container">
        <div className="email-widget__input-container">
          <div className="email-widget__input-title">
            <span>Email body</span>
            <div className="widget-common__heading widget-common__icons-container email-widget__top-container">
              <AttributePicker
                className="email-widget__attribute-picker"
                onAttributePicked={updateInsertAttributeBody}
                color="#9b9b9b"
              />
              <EmojiPicker
                className="email-widget__emoji-picker"
                onEmojiPicked={updateInsertEmojiBody}
              />
            </div>
          </div>
          <div>
            <AttributeContainingTextInput
              className="email-widget__input email-widget__input--body"
              multiline
              autosize={false}
              value={bodyValue}
              onChange={onChangeBody}
              onBlur={onBlur}
              attributes={attributes}
              placeholder="Enter you message here"
              inputRef={setEmailBodyRef}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
